import React, { useState } from 'react';
import styled from 'styled-components';
import { ChevronDown } from 'lucide-react';

const StyledToolbar = styled.div<{ active: boolean }>`
  position: absolute;
  z-index: 1;
  left: 0;
  top: 50%;
  display: ${p => (p.hidden ? 'none' : 'flex')};
  flex-direction: row-reverse;
  align-items: center;
  transform: ${p =>
    p.active ? 'translate(0px, -50%)' : 'translate(-80px, -50%)'};
  transition: transform 0.4s ease-in-out;

  &.active {
    transform: translateX(0);
  }
`;

const StyledToolbarContent = styled.div<{ active: boolean }>`
  width: 80px;
  min-height: 100px;
  justify-content: space-around;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 15px 10px;
  background-color: ${p => p.theme.colors.surface};
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
  transition: box-shadow 0.3s ease-in-out;
  box-shadow: ${p =>
    p.active
      ? '2px 2px 8px rgba(0, 0, 0, 0.18), 0 1px 3px rgba(0,0,0,0.12)'
      : 'none'};

  &:before {
    content: '';
    position: absolute;
    z-index: -1;
    height: 100%;
    width: 30px;
    left: -30px;
    transition: box-shadow 0.3s ease-in-out;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.18);
  }

  > button {
    margin: 5px 0;
  }
`;

const StyledChevron = styled.button<{ active: boolean }>`
  position: relative;
  left: -1px;
  appearance: none;
  border: 1px solid ${p => p.theme.colors.borderSubtle};
  border-left: none;
  background-color: ${p => p.theme.colors.surface};
  color: ${p => p.theme.colors.black};
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  margin: 0;
  padding: 0;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 35px;
  transition: box-shadow 0.3s ease-in-out;
  box-shadow: ${p =>
    p.active
      ? '2px 2px 8px rgba(0, 0, 0, 0.18), 0 1px 3px rgba(0,0,0,0.12)'
      : 'none'};
  z-index: 1;

  img,
  svg {
    display: block;
    width: 20px;
    height: 20px;
    transition: transform 0.4s;
    transform: ${p => (p.active ? 'rotate(90deg)' : 'rotate(270deg)')};
  }
`;

interface Props {
  hidden: boolean;
  children?: React.ReactNode;
}

const VMToolbar = (props: Props) => {
  const [toolbarActive, setToolbarActive] = useState(false);

  const toggleToolbar = () => {
    setToolbarActive(!toolbarActive);
  };

  return (
    <StyledToolbar active={toolbarActive} hidden={props.hidden}>
      <StyledChevron
        active={toolbarActive}
        aria-label={toolbarActive ? 'Close toolbar' : 'Open toolbar'}
        onClick={() => toggleToolbar()}
      >
        <ChevronDown size={20} aria-hidden={true} />
      </StyledChevron>
      <StyledToolbarContent active={toolbarActive}>
        {props.children}
      </StyledToolbarContent>
    </StyledToolbar>
  );
};

export { VMToolbar };
